import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AnimatedButtonModule } from '@shared/components/animated-button/animated-button.module';
import { ModalFormHostComponent } from './modal-form-host.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        AnimatedButtonModule
    ],
    declarations: [ModalFormHostComponent],
    exports: [ModalFormHostComponent]
})
export class ModalFormHostModule { }
